import { Breadcrumb, configureScope, init, Scope } from "@sentry/browser";
import { SentryBreadcrumbHint } from "@sentry/types";

init({
  beforeBreadcrumb: (
    breadcrumb: Breadcrumb,
    hint?: SentryBreadcrumbHint | undefined
  ) => {
    if (breadcrumb.category === "ui.click" && hint) {
      const { target }: { target?: HTMLElement } = hint.event;

      if (target && target.textContent) {
        breadcrumb.message = target.textContent + ` (${breadcrumb.message})`;
      }
    }

    return breadcrumb;
  },
  dsn:
    process.env.NODE_ENV === "production"
      ? "https://43ea37b6a6364ad69d050561682bfc14@sentry.io/1279951"
      : undefined,
  environment: process.env.NODE_ENV,
  release: process.env.GIT_REV
});

let lastUserSlug: string | null = null;
window.addEventListener("storage", () => {
  const userSlug = localStorage.getItem("user_slug") || "unknown";

  if (userSlug !== lastUserSlug) {
    configureScope((scope: Scope) => {
      scope.setUser({ username: userSlug });
    });

    lastUserSlug = userSlug;
  }
});



// WEBPACK FOOTER //
// ./src/util/sentry.ts